import { TEXTE, NOMBRE, OUI_NON } from '@/configuration/jsonEditor/jsonEditorConfig';

function getDefaultValue(type) {
  switch (type) {
    case TEXTE:
      return '';
    case OUI_NON:
      return false;
    case NOMBRE:
      return null;
    default:
      return '';
  }
}
export default function convertValue(value, type) {
  if ([undefined, null, 'null'].includes(value)) {
    return getDefaultValue(type);
  }
  switch (type) {
    case TEXTE:
      return String(value);
    case OUI_NON:
      if (value === 'true' || value === true) return true;
      if (value === 'false' || value === false) return false;
      return null;
    case NOMBRE:
      return Number.isNaN(value) ? null : Number(value);
    default:
      return value;
  }
}
